'use client';

import { useIsFetching, useQueryClient } from '@tanstack/react-query';

// In place of a reload, which would throw away what a visitor typed and which a
// page opened from the Home Screen has no control for.
export const useRetryReads = () => {
  const queryClient = useQueryClient();
  const isRetrying = useIsFetching() > 0;

  return {
    retry: () => queryClient.refetchQueries({ type: 'active' }),
    isRetrying,
  };
};
